import { Component, Input, OnInit } from '@angular/core';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { CommunicationModel, EmailPopupModel, Lookups, PopupModel, PopupModelReturn, PopupSetupModel, ServiceProvider, SP_Type } from '../../../AllTableClasses';
import { ServiceProviderService } from '../../../Services/service-provider.service';
import { LookupsService } from '../../../Services/lookups.service';
import { Subject, takeUntil } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-service-popup',
  templateUrl: './service-popup.component.html',
  styleUrl: './service-popup.component.scss'
})
export class ServicePopupComponent implements OnInit {

  private destroy$ = new Subject<void>();

  popup: PopupSetupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();

  submitted = false;
  @Input() Data!: ServiceProvider;
  public service: ServiceProvider = new ServiceProvider();

  public SP_Types: Array<SP_Type> = new Array<SP_Type>();
  public durations: Array<Lookups> = new Array<Lookups>();
  public selectedDuration!: string;
  public serviceSection!: string;

  constructor(
    private popupNotificationService: PopupNotificationService,
    private serviceProviderService: ServiceProviderService,
    private lookupService: LookupsService,
  ) { }

  ngOnInit(): void {
    this.popupNotificationService.serviceNotification$.pipe(takeUntil(this.destroy$)).subscribe((popup: PopupSetupModel | null) => {
      this.popup = popup;
      this.CategoryGet();
      this.DurationsGet();
      if (popup?.Data.Guid) {
        this.ServiceProviderGetByGuid();
      }
    });
    
  }

  public ServiceProviderGetByGuid() {
    this.serviceProviderService.ServiceProviderGetByGuid(this.popup?.Data.Guid, (data) => {
      if (data.Success) {
        this.service = data.Data;
        this.serviceSection = this.SP_Types.filter(sp => sp.Guid == this.service.SPTypeGuid)[0].SPType;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public CategoryGet() {
    this.serviceProviderService.SPTypeGet((data) => {
      if (data.Success) {
        this.SP_Types = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public DurationsGet() {
    this.lookupService.DurationsGet((data) => {
      if (data.Success) {
        this.durations = data.Data;
        
      }
      else {

      }
    }, (error) => { });
  }

  public onSubmit(form: NgForm): void {
    this.submitted = true;
    if (form.valid) {
      this.ButtonClick();
    } else {
      console.log('Form is not valid');
    }
  }

  ButtonClick() {
    if (this.popup?.Button) {
      this.popupReturn.Result = this.popup.Button.Result;
      this.service.Active = true;
      //this.service.Duration = parseInt(this.selectedDuration);
      this.popupReturn.Data = this.service;
      this.clearPopup();
      this.popupNotificationService.ResolveServicePopup(this.popupReturn);
    }
  }
  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.clearPopup();
      this.popupNotificationService.ResolveServicePopup(this.popupReturn);
    }
  }

  PopupEvent(event: string) {
    if (event === 'close') {
      this.popupReturn.Result = 'close';
      this.clearPopup();
      this.popupNotificationService.ResolveServicePopup(this.popupReturn);
    }

  }

  clearPopup() {
    this.popup = null;
    this.service = new ServiceProvider();
  }

  ngOnDestroy(): void {
    // Emit and complete the destroy$ Subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
